import { messages } from '@/lib/messages'

import type { RefreshDiff } from './materialize'

const t = messages.documents.runs.refresh

/** `condition.<n>` / `repeat.<n>` anahtarı (şablondaki 0 tabanlı sıra) -> "Koşul n+1" / "Tekrar n+1". */
function blockLabel(key: string) {
  const [kind, index] = key.split('.')
  const n = Number(index) + 1
  return kind === 'condition' ? t.condition(n) : t.repeat(n)
}

/** "Verileri yenile" sonucu: değişen rakam sayısı ve gözden geçirilecek (işaretli) bloklar. */
export function RunRefreshNotice({ diff }: { diff: RefreshDiff }) {
  const marked = [...diff.conditions, ...diff.repeats]
  return (
    <div role="status" className="border-border flex flex-col gap-2 rounded-md border p-3 text-sm">
      <span className="font-medium">{t.done(diff.figures)}</span>
      {marked.length > 0 && (
        <>
          <span className="text-muted-foreground">{t.textKept}</span>
          <ul className="flex flex-wrap gap-2">
            {marked.map((key) => (
              <li
                key={key}
                data-testid="refresh-marked"
                className="border-warning text-warning rounded-md border px-2 py-0.5"
              >
                {blockLabel(key)}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  )
}
